export enum ValidationCodes {
  NO_FILTERS = 'NO_FILTERS',
  NO_EVENT_NAME = 'NO_EVENT_NAME',
  DUPLICATE_NAME = 'DUPLICATE_NAME',
  TIME_WINDOW_START_AFTER_END = 'TIME_WINDOW_START_AFTER_END',
  TIME_WINDOW_OUTSIDE_STUDY_PERIOD = 'TIME_WINDOW_OUTSIDE_STUDY_PERIOD',
}
